// editorStore.ts
import { create } from "zustand";
import { CanvasImage } from "./CanvasImage"; // Adjust path if needed
import { subscribeWithSelector } from "zustand/middleware";

type StickerSectionState = {
    showStickersSection: boolean;
    setShowStickersSection: (value: boolean) => void;

    canvasImageSelected: boolean;
    setCanvasImageSelected: (value: boolean) => void;

    toolSelected: string;
    setToolSelected: (tool: string) => void;

    toolSelectedRef: React.MutableRefObject<string>;
    currentCanvasImageSelectedRef: React.MutableRefObject<CanvasImage | null>;

    cursorStyle: string;
    setCursorStyle: (style: string) => void;

    stickerTrayRerender: boolean;
    setStickerTrayRerender: (value: boolean) => void;

    phoneModel: string | null;
    setPhoneModel: (phoneModel: string | null) => void;

    isAtTop: boolean;
    isAtBottom: boolean;
    setLayerStatus: (status: { isAtTop: boolean; isAtBottom: boolean }) => void;

    canUndo: boolean;
    canRedo: boolean;
    setUndoRedo: (status: { canUndo: boolean; canRedo: boolean }) => void;

    // New states
    showBackgroundImage: boolean;
    setShowBackgroundImage: (value: boolean) => void;

    backgroundBitmap: ImageBitmap | null;
    setBackgroundBitmap: (bitmap: ImageBitmap | null) => void;

    backgroundColor: string;
    setBackgroundColor: (color: string) => void;

    caseFinish: string;
    setCaseFinish: (finish: string) => void;

    magSafe: boolean;
    setMagSafe: (magSafe: boolean) => void;

    tutorialToolTipShown: boolean;
    setTutorialToolTipShown: (shown: boolean) => void;

    uuid: string | null;
    setUuid: (uuid: string) => void;

    ghostsEnabled: boolean;
    setGhostsEnabled: (ghostsEnabled: boolean) => void;

    ghostFreq: number;
    setGhostFreq: (freq: number) => void;

    ghostOpacity: number;
    setGhostOpacity: (opacity: number) => void;

    ghostSize: number;
    setGhostSize: (size: number) => void;

    isPortrait: boolean;
    setIsPortrait: (isPortrait: boolean) => void

    previewImageLinks: string[];
    setPreviewImageLinks: (links: string[]) => void;

    hasPinched: boolean;
    setHasPinched: (value: boolean) => void;

    hasZoomed: boolean;
    setHasZoomed: (value: boolean) => void;

};
export const useStickerSectionStore = create(
    subscribeWithSelector<StickerSectionState>((set) => ({
        showStickersSection: true,
        setShowStickersSection: (value) => set({ showStickersSection: value }),

        canvasImageSelected: false,
        setCanvasImageSelected: (value) => set({ canvasImageSelected: value }),

        toolSelected: "selector",
        setToolSelected: (tool) => set({ toolSelected: tool }),

        toolSelectedRef: { current: "selector" },
        currentCanvasImageSelectedRef: { current: null },

        cursorStyle: "default",
        setCursorStyle: (style) => set({ cursorStyle: style }),

        stickerTrayRerender: false,
        setStickerTrayRerender: (value) => set({ stickerTrayRerender: value }),

        phoneModel: null,
        setPhoneModel: (phoneModel) => set({ phoneModel }),

        isAtTop: false,
        isAtBottom: false,
        setLayerStatus: ({ isAtTop, isAtBottom }) => set({ isAtTop, isAtBottom }),

        canUndo: false,
        canRedo: false,
        setUndoRedo: ({ canUndo, canRedo }) => set({ canUndo, canRedo }),

        showBackgroundImage: false,
        setShowBackgroundImage: (value) => set({ showBackgroundImage: value }),

        backgroundBitmap: null,
        setBackgroundBitmap: (bitmap) => set({ backgroundBitmap: bitmap }),

        backgroundColor: "#3d5a5a",
        setBackgroundColor: (color) => set({ backgroundColor: color }),

        caseFinish: 'Glossy',
        setCaseFinish: (finish) => set({ caseFinish: finish }),

        magSafe: false,
        setMagSafe: (magSafe) => set({ magSafe: magSafe }),

        tutorialToolTipShown: false,
        setTutorialToolTipShown: (shown) => set({ tutorialToolTipShown: shown }),

        uuid: null,
        setUuid: (uuid) => set({ uuid: uuid }),

        ghostsEnabled: false,
        setGhostsEnabled: (ghostsEnabled) => set({ ghostsEnabled: ghostsEnabled }),

        ghostFreq: 10,
        setGhostFreq: (freq: number) => set({ ghostFreq: freq }),

        ghostOpacity: 70,
        setGhostOpacity: (opacity: number) => set({ ghostOpacity: opacity }),

        ghostSize: 100,
        setGhostSize: (size: number) => set({ ghostSize: size }),

        isPortrait: false,
        setIsPortrait: (isPortrait: boolean) => set({ isPortrait: isPortrait }),

        previewImageLinks: [],
        setPreviewImageLinks: (links: string[]) => set({ previewImageLinks: links }),

        hasPinched: false,
        setHasPinched: (value) => set({ hasPinched: value }),

        hasZoomed: false,
        setHasZoomed: (value) => set({ hasZoomed: value }),
    }))
);
